import Marquee from 'vanilla-marquee';

export class NoticeMarquee {
    private marquee: Marquee | null = null;
    private element: HTMLElement;

    constructor(element: HTMLElement) {
        this.element = element;
        this.init();
    }

    private init(): void {
        const marqueeContainer = this.element.querySelector('.site-header__notice-marquee') as HTMLElement;

        if (!marqueeContainer) return;

        // Check if there are multiple messages to warrant a marquee
        const messages = marqueeContainer.querySelectorAll('.site-header__notice-item');

        if (messages.length > 1) {
            this.marquee = new Marquee(marqueeContainer, {
                speed: 60, // Pixels per second
                duplicated: true, // Duplicate content for seamless loop
                pauseOnHover: true, // Pause when user hovers
                direction: 'right', // Direction of movement
                startVisible: true
            });
        } else {
            // If only one message, center it instead of marquee
            marqueeContainer.style.justifyContent = 'center';
        }
    }

    public destroy(): void {
        if (this.marquee) {
            this.marquee.destroy();
            this.marquee = null;
        }
    }
}

// Auto-initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    const noticeElements = document.querySelectorAll('[data-js="NoticeMarquee"]');

    noticeElements.forEach((element) => {
        new NoticeMarquee(element as HTMLElement);
    });
});
